// extracted by mini-css-extract-plugin
export default {"Calulations":"TotalFares_Calulations__82QqJ","CauluationIcon":"TotalFares_CauluationIcon__ryX62"};